<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part main_top_search">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="orderNum" :placeholder="$t('message.orderSearchPlaceholder')"></el-input>
        </div>
        <div class="search_item">
          <el-input v-model="orderSenderName" :placeholder="$t('message.orderSearchPlaceholder2')"></el-input>
        </div>
        <div class="search_item">
          <el-date-picker v-model="orderTime" align="center" type="datetimerange" range-separator=" - " :start-placeholder="$t('message.orderTimeStartHolder')" :end-placeholder="$t('message.orderTimeEndHolder')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <div class="search_item">
          <el-select v-model="orderStatus" :placeholder="$t('message.exportDatePlaceholder')" multiple collapse-tags>
            <el-option v-for="item in $t('message.orderStatusList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-cascader :value="orderSelProvince" :options="orderProvince" @change="handleChange" :placeholder="$t('message.orderSearchPlaceholder3')" clearable :show-all-levels="false"></el-cascader>
        </div>
        <div class="search_item">
          <el-input v-model="containerOrderNumber" :placeholder="$t('message.containerOrderNumber')"></el-input>
        </div>
        <div class="search_item">
          <el-input v-model="remark" :placeholder="$t('message.orderSearchPlaceholder4')"></el-input>
        </div>
        <div class="search_btn" @click="searchOrderNum">{{$t('message.searchBtnText')}}</div>
        <div class="search_btn" @click="importExcel">{{$t('message.importExcelTitle')}}</div>
        <div class="search_btn" @click="exportOrders">{{$t('message.exportText')}}</div>
        <div class="search_btn" v-if="selOrders.length !== 0" @click="showSetContainer">{{$t('message.setOrdersContainer')}}</div>
        <div class="search_btn" v-if="selOrders.length !== 0" @click="delOrders">{{$t('message.delOrderText')}}</div>
        <div class="add_btn" @click="addNewOrder"><img class="add_icon" src="@/assets/addIcon.svg" />{{$t('message.addOrderBtnText')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <!-- 列表 -->
    <!-- 订单管理列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="orderList" :data="orderList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" @sort-change="sortChange" @selection-change="selectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="65"></el-table-column>
          <el-table-column :label="$t('message.containerOrderNumber')" prop="containerCoding" min-width="210"></el-table-column>
          <el-table-column :label="$t('message.arrivePort')" prop="JZXCITY" width="100"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle1')" prop="ORDERNUM" min-width="210"></el-table-column>
          <el-table-column :label="$t('message.orderRemarkTitle')" prop="REMARK" min-width="150"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle2')" width="120">
            <template slot-scope="scope">
              <a :href="scope.row.imgSrc" :download="scope.row.TXM">
                <img class="barCodeImg" :src="scope.row.imgSrc" />
              </a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.orderTableTitle3')" width="100">
            <template slot-scope="scope">
              <el-button class="checkBtn" @click.native.prevent="checkLogistics(scope.row)">{{$t('message.orderTableCheckTitle')}}</el-button>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.addresseeAddressTitle')" prop="SJDZ" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('message.addresseeCompanyTitle')" prop="SJGS" min-width="150"></el-table-column>
          <el-table-column :label="$t('message.addresseeNameTitle')" prop="SJR" width="140"></el-table-column>
          <el-table-column :label="$t('message.addresseePhoneTitle')" prop="SJRPHONE" width="150"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle10')" prop="status" width="120"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle11')" prop="addTime" min-width="120" sortable="custom"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle7')" prop="WPSL" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle8')" prop="WPZL" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle9')" prop="WPTJ" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle4')" prop="JJGS" min-width="150"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle5')" prop="JJR" width="140"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle6')" prop="JJRPHONE" width="150"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="160" fixed="right" >
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <a target="_blank" :href="url + '/pdf/WlOrder?ORDERNUM=' + scope.row.ORDERNUM">pdf</a>
                <el-button class="operation_btn updateBtn" type="text" size="small" @click.native.prevent="updateOrder(scope.row)" v-if="isAdmin"></el-button>
                <el-button class="operation_btn delBtn" type="text" size="small" @click.native.prevent="delOrder(scope.row)" v-if="isAdmin"></el-button>
                <el-button class="operation_btn cancelBtn" type="text" size="small" @click.native.prevent="cancellationOrder(scope.row.ID, scope.row.STATE)" v-if="!isAdmin && scope.row.STATE !== '1' && scope.row.STATE !== '2'"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
    <!-- 列表 -->
    <el-dialog :visible.sync="newOrder" :title="addOrderTitle" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="60%" top="5vh">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.orderTableTitle4')}}</span>
            <el-input v-model="senderCompany" :placeholder="$t('message.placeholder')"></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.orderTableTitle5')}}</span>
            <el-input v-model="senderName" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.senderPhoneTitle')}}</span>
            <el-input v-model="senderPhone" :placeholder="$t('message.placeholder')" :disabled="newId !== 0"></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.senderEmailTitle')}}</span>
            <el-input v-model="senderEmail" :placeholder="$t('message.placeholder')" :disabled="newId !== 0"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.senderProvienceTitle')}}</span>
            <el-input v-model="senderProvience" :placeholder="$t('message.placeholder')"></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.senderCityTitle')}}</span>
            <el-input v-model="senderCity" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.senderAddressTitle')}}</span>
            <el-input v-model="senderAddress" :placeholder="$t('message.placeholder')"></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.orderTableTitle7')}}(pc)</span>
            <el-input v-model="goodsNum" :placeholder="$t('message.placeholder')" type="number"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.orderTableTitle8')}}(kg)</span>
            <el-input v-model="goodsWeight" :placeholder="$t('message.placeholder')" type="number"></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.orderTableTitle9')}}(m³)</span>
            <el-input v-model="goodsVolume" :placeholder="$t('message.placeholder')" type="number"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item" v-if="!isAdmin">
            <span class="dialog_item_title">{{$t('message.addresseeInfoTitle')}}</span>
            <el-select v-model="addresseeName" @change="addresseeInfoChange">
              <el-option v-for="(item, index) in addresseeInfoList" :key="index" :label="item.LXR" :value="index"></el-option>
            </el-select>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseeProvienceTitle')}}</span>
            <el-select v-model="addresseeProvience" filterable :placeholder="$t('message.deliveryAreaTitle')" :disabled="newId !== 0">
              <el-option v-for="item in prefecturesList" :key="item.code" :label="item.value" :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseeCityTitle')}}</span>
            <el-input v-model="addresseeCity" :placeholder="$t('message.placeholder')"></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseeTitle')}}</span>
            <el-input v-model="addressee" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseeCompanyTitle')}}</span>
            <el-input v-model="addresseeCompany" :placeholder="$t('message.placeholder')"></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseeNameTitle')}}</span>
            <el-input v-model="addresseeName" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.addresseePhoneTitle')}}</span>
            <el-input v-model="addresseePhone" :placeholder="$t('message.placeholder')"></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.orderRemarkTitle')}}</span>
            <el-input v-model="orderRemark" :placeholder="$t('message.placeholder')" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" maxlength="500" show-word-limit></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.containerOrderModel')}}</span>
            <el-select v-model="containerOrderModel">
              <el-option v-for="item in modelOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.arrivePort')}}</span>
            <el-select v-model="arrivePort">
              <el-option v-for="item in cityOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.containerOrderNumber')}}</span>
            <el-input v-model="containerNumber" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="newOrder = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="addNewConfirm">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog :title="$t('message.importExcelTitle')" :visible.sync="uploadExcel" width="90%" destroy-on-close :close-on-click-modal="false">
      <div class="top_search_part">
        <div class="search_box">
          <a class="search_btn" style="color: #FFFFFF;" :href="imgSrc('Template.xlsx')">{{$t('message.downLoadExcel')}}</a>
        </div>
        <div class="search_box">
          <el-upload class="importBtnBox" :action="uploadUrl" :on-success="handleSuccess" :on-error="handleError" :limit="1" :before-upload="beforeAvatarUpload">
            <el-button class="search_btn">{{$t('message.selectExcel')}}</el-button>
          </el-upload>
          <el-button class="search_btn" @click="getImportExcel">{{$t('message.importExcelCheck')}}</el-button>
          <el-button class="search_btn" @click="confirmImportExcel" :disabled="canConfirmImport">{{$t('message.confirmImportExcel')}}</el-button>
        </div>
      </div>
      <el-table id="excelTable" :data="excelTable" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer">
        <el-table-column label="寄件人email/Sender email" prop="寄件人email/Sender email"></el-table-column>
        <el-table-column label="寄件人姓名/name of sender" prop="寄件人姓名/name of sender"></el-table-column>
        <el-table-column label="寄件人电话/Sender mobile" prop="寄件人电话/Sender mobile"></el-table-column>
        <el-table-column label="寄件公司/Name of sending company" prop="寄件公司/Name of sending company"></el-table-column>
        <el-table-column label="寄件县/省/Mailing province/City" prop="寄件县/省/Mailing province/City"></el-table-column>
        <el-table-column label="寄件地址/Mailing address" prop="寄件地址/Mailing address"></el-table-column>
        <el-table-column label="寄件市/Mailing City" prop="寄件市/Mailing City"></el-table-column>
        <el-table-column label="收件人姓名/Recipient name" prop="收件人姓名/Recipient name"></el-table-column>
        <el-table-column label="收件人电话/Recipient phone" prop="收件人电话/Recipient phone"></el-table-column>
        <el-table-column label="收件公司名/Name of receiving company" prop="收件公司名/Name of receiving company"></el-table-column>
        <el-table-column label="收件县/省/Receiving province/City" prop="收件县/省/Receiving province/City"></el-table-column>
        <el-table-column label="收件地址/Receiving address" prop="收件地址/Receiving address"></el-table-column>
        <el-table-column label="收件市/Mailing City/county" prop="收件市/Mailing City/county"></el-table-column>
        <el-table-column label="物品体积(m³)/Item volume(m³)" prop="物品体积(m³)/Item volume(m³)"></el-table-column>
        <el-table-column label="物品数量(PC)/Number of items(pc)" prop="物品数量(PC)/Number of items(pc)"></el-table-column>
        <el-table-column label="物品称重(KG)/Item weighing(kg)" prop="物品称重(KG)/Item weighing(kg)"></el-table-column>
        <el-table-column label="集装箱编码/Container code" prop="集装箱编码/Container code"></el-table-column>
        <el-table-column label="集装箱型号/Container model" prop="集装箱型号/Container model"></el-table-column>
        <el-table-column label="抵达港口/Port of arrival" prop="抵达港口/Arrival at port"></el-table-column>
        <el-table-column label="备注/Remark" prop="备注/Remark"></el-table-column>
        <el-table-column label="fail reason" prop="checked"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="showContainerSetting" :title="$t('message.setOrdersContainer')" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="35%">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.containerOrderNumber')}}</span>
            <el-input v-model="containerNumber" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.containerOrderModel')}}</span>
            <el-select v-model="containerOrderModel">
              <el-option v-for="item in modelOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.arrivePort')}}</span>
            <el-select v-model="arrivePort">
              <el-option v-for="item in cityOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showContainerSetting = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="confirmSetting">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getProvince, imgSrc, getOrderList, setOrder, delOrder, getUserData, setOrderState, uploadImg, readExcel, confirmImportExcel, setOrdersContainer, exportOrders, HTTPS } from '@/api/getData.js'
  import prefectures from '@/js/prefectures.json'
  export default {
    name: 'ordersManage',
    data () {
      return {
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 30, 50, 100],
        totalSize: 0,
        orderList: [],
        orderNum: '',
        orderSenderName: '',
        orderStatus: [0, 1, 2],
        orderTime: null,
        orderProvince: [], // 收件省份
        orderSelProvince: '', // 收件省份选择
        remark: '',
        containerOrderNumber: '',
        prop: null, // 排序字段
        order: '', // 排序方式，desc
        newOrder: false,
        newId: 0,
        // showOrderNumInput: false,
        newOrderNum: '',
        senderCompany: '',
        senderName: '',
        senderPhone: '',
        senderEmail: '',
        goodsNum: '',
        goodsWeight: '',
        goodsVolume: '',
        senderProvience: '',
        senderCity: '',
        senderAddress: '',
        addresseeProvience: '',
        addresseeCity: '',
        addressee: '',
        addresseeCompany: '',
        addresseeName: '',
        addresseePhone: '',
        // addresseeEmail: '',
        orderRemark: '',
        containerNumber: '',
        containerOrderModel: '',
        modelOptions: ['40GP/HQ', '20GP/HQ', 'CFS', 'NRT', 'KIX', 'HND'],
        arrivePort: '',
        cityOptions: ['東京', '大阪'],
        addOrderTitle: '',
        isAdmin: false,
        addresseeInfoList: [],
        prefecturesList: [],
        uploadExcel: false,
        excelNewFileName: '',
        excelTable: [],
        canConfirmImport: true,
        selOrders: [],
        showContainerSetting: false,
        exportJson: {}
      }
    },
    created () {
      this.prefecturesList = prefectures
      this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin')
      this.getProvince()
      let param = this.$store.state.JHSS_orderManage_param
      if (param.PAGE) this.page_no = param.PAGE
      if (param.TYPE) this.page_size = param.TYPE
      if (param.ORDERNUM) this.orderNum = param.ORDERNUM
      if (param.JJR) this.orderSenderName = param.JJR
      if (param.UADDTIME && param.DADDTIME) this.orderTime = [param.UADDTIME, param.DADDTIME]
      if (param.STATE) this.orderStatus = param.STATE.split(',').map(item => { return parseInt(item) })
      if (param.CITY2) this.orderSelProvince = param.CITY2
      if (param.ORDERANDREMARK) this.remark = param.ORDERANDREMARK
      if (param.JZXNUM) this.containerOrderNumber = param.JZXNUM
      // 查询订单列表
      this.getOrderList(param)
    },
    methods: {
      // 查询订单省份
      async getProvince () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let res = await getProvince({})
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        this.orderProvince = res.data.map(item => {
          item.value = item.PROVINCE2
          item.label = item.PROVINCE2
          item.children = item.children.map(child => {
            child.value = child.CITY2
            child.label = child.CITY2
            return child
          })
          return item
        })
      },
      handleChange (list) {
        this.orderSelProvince = list.length === 0 ? '' : list[1]
      },
      // 查询订单列表
      async getOrderList (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
        param.USERID = this.$store.state.JHSS.personalUserid
        param.STATE = this.orderStatus.join(',')
        param.CITY2 = this.orderSelProvince
        if (this.prop) {
          param.ORDERNAME = this.prop
        }
        param.DOA = this.order
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getOrderList(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        this.exportJson = param
        // console.log(res.data.ds)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        let orderState2 = this.$t('message.orderState2')
        let orderState1 = this.$t('message.orderState1')
        let orderState0 = this.$t('message.orderState0')
        let orderState3 = this.$t('message.orderState3')
        this.orderList = res.data.dt.map(item => {
          item.index = ++index
          item.imgSrc = imgSrc(item.TXM)
          item.containerCoding = !item.JZXNUM ? '' : (item.JZXNUM + '（' + item.JZXSIZE + '）')
          // item.status = item.STATE === '2' ? orderState2 : (item.STATE === '1' ? orderState1 : orderState0)
          switch (item.STATE) {
            case '0':
              item.status = orderState0
              break
            case '1':
              item.status = orderState1
              break
            case '2':
              item.status = orderState2
              break
            default:
              item.status = orderState3
          }
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          return item
        })
        this.$store.commit('setOrderManageParam', param)
      },
      // 搜索订单编号
      searchOrderNum () {
        this.page_no = 1
        this.searchFun()
      },
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        this.searchFun()
      },
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        this.searchFun()
      },
      searchFun () {
        let param = {}
        // 查询客户管理
        if (this.orderNum) {
          param.ORDERNUM = this.orderNum
        }
        if (this.orderSenderName) {
          param.JJR = this.orderSenderName
        }
        if (this.orderTime) {
          param.UADDTIME = this.orderTime[0]
          param.DADDTIME = this.orderTime[1]
        }
        if (this.remark) param.ORDERANDREMARK = this.remark
        if (this.containerOrderNumber) param.JZXNUM = this.containerOrderNumber
        this.getOrderList(param)
      },
      // 导出订单
      async exportOrders () {
        const message = this.$message({
          message: 'loading...',
          iconClass: 'el-icon-loading',
          duration: 0
        })
        let param = this.exportJson
        let res = await exportOrders(param)
        message.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          // console.log(res.data)
          let str = HTTPS + "/xlsx/" + res.data
          window.open(str)
        }
      },
      // 添加订单
      async addNewOrder () {
        // 查询登录客户寄件地址
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = { USERID: this.$store.state.JHSS.personalUserid }
        let res = await getUserData(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        if (!this.isAdmin) {
          // 非管理员
          this.senderCompany = res.data.MyAddree[0].GUDING1
          this.senderName = res.data.MyAddree[0].USHOWNAME
          this.senderPhone = res.data.MyAddree[0].TELPHONE
          this.senderEmail = res.data.MyAddree[0].GUDING2
          this.senderProvience = res.data.MyAddree[0].GUDING3
          this.senderCity = res.data.MyAddree[0].GUDING4
          this.senderAddress = res.data.MyAddree[0].GUDING5
          this.addresseeInfoList = res.data.ToAddree
        } else {
          // 管理员
          this.senderCompany = ''
          this.senderName = ''
          this.senderPhone = ''
          this.senderEmail = ''
          this.senderProvience = ''
          this.senderCity = ''
          this.senderAddress = ''
          this.addresseeInfoList = ''
        }
        this.newId = 0
        // this.showOrderNumInput = false
        this.newOrderNum = ''
        this.goodsNum = ''
        this.goodsWeight = ''
        this.goodsVolume = ''
        
        this.addresseeProvience = ''
        this.addresseeCity = ''
        this.addressee = ''
        this.addresseeCompany = ''
        this.addresseeName = ''
        this.addresseePhone = ''
        this.orderRemark = ''
        this.containerNumber = ''
        this.containerOrderModel = ''
        this.arrivePort = ''
        this.newOrder = true
        this.addOrderTitle = this.$t('message.addOrderBtnText')
      },
      addresseeInfoChange (val) {
        // console.log(val)
        this.addresseeProvience = this.addresseeInfoList[val].PROVINCE2
        this.addresseeCity = this.addresseeInfoList[val].CITY2
        this.addressee = this.addresseeInfoList[val].WLADDRESS
        this.addresseeCompany = this.addresseeInfoList[val].GSMC
        this.addresseeName = this.addresseeInfoList[val].LXR
        this.addresseePhone = this.addresseeInfoList[val].LXPHONE
      },
      // 确定添加订单
      async addNewConfirm () {
        if (!this.senderCompany) {
          this.$message.error(this.$t('message.orderTableTitle4'))
        } else if (!this.senderName) {
          this.$message.error(this.$t('message.orderTableTitle5'))
        } else if (!this.senderPhone) {
          this.$message.error(this.$t('message.senderPhoneTitle'))
        } else if (!this.senderEmail) {
          this.$message.error(this.$t('message.senderEmailTitle'))
        } else if (!this.goodsNum) {
          this.$message.error(this.$t('message.orderTableTitle7'))
        } else if (!this.goodsWeight) {
          this.$message.error(this.$t('message.orderTableTitle8'))
        } else if (!this.goodsVolume) {
          this.$message.error(this.$t('message.orderTableTitle9'))
        } else if (!this.senderProvience) {
          this.$message.error(this.$t('message.senderProvienceTitle'))
        } else if (!this.senderCity) {
          this.$message.error(this.$t('message.senderCityTitle'))
        } else if (!this.senderAddress) {
          this.$message.error(this.$t('message.senderAddressTitle'))
        } else if (!this.addresseeProvience) {
          this.$message.error(this.$t('message.addresseeProvienceTitle'))
        } else if (!this.addresseeCity) {
          this.$message.error(this.$t('message.addresseeCityTitle'))
        } else if (!this.addressee) {
          this.$message.error(this.$t('message.addresseeTitle'))
        } else if (!this.addresseeCompany) {
          this.$message.error(this.$t('message.addresseeCompanyTitle'))
        } else if (!this.addresseeName) {
          this.$message.error(this.$t('message.addresseeNameTitle'))
        } else if (!this.addresseePhone) {
          this.$message.error(this.$t('message.addresseePhoneTitle'))
        } else if (this.containerNumber && !this.containerOrderModel) {
          this.$message.error(this.$t('message.containerOrderModel'))
        } else if (this.containerNumber && !this.arrivePort) {
          this.$message.error(this.$t('message.arrivePort'))
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let area = ''
          for (let i = 0; i < this.prefecturesList.length; i++) {
            if (this.prefecturesList[i]['value'] === this.addresseeProvience) {
              area = this.prefecturesList[i]['code']
            }
          }
          let now = new Date()
          let year = now.getFullYear()
          let month = (now.getMonth() + 1) > 9 ? (now.getMonth() + 1) : '0' + (now.getMonth() + 1)
          let date = now.getDate() > 9 ? now.getDate() : '0' + now.getDate()
          let number = this.goodsNum.length < 4 ? ('0000' + this.goodsNum).substr(-4) : this.goodsNum
          let weight = this.goodsWeight.length < 4 ? ('0000' + this.goodsWeight).substr(-4) : this.goodsWeight
          this.newOrderNum = '46' + area + year + month + date + weight + number
          let param = {
            ID: this.newId,
            ADDUSERID: this.$store.state.JHSS.personalUserid,
            ORDERNUM: this.newOrderNum,
            JJGS: this.senderCompany,
            JJR: this.senderName,
            JJRPHONE: this.senderPhone,
            JJREMAIL: this.senderEmail,
            PROVINCE1: this.senderProvience,
            CITY1: this.senderCity,
            GUDING1: this.senderAddress,
            SJGS: this.addresseeCompany,
            SJR: this.addresseeName,
            SJRPHONE: this.addresseePhone,
            PROVINCE2: this.addresseeProvience,
            CITY2: this.addresseeCity,
            SJDZ: this.addressee,
            WPSL: this.goodsNum,
            WPZL: this.goodsWeight,
            WPTJ: this.goodsVolume,
            REMARK: this.orderRemark,
            JZXNUM: this.containerNumber,
            JZXSIZE: this.containerOrderModel,
            JZXCITY: this.arrivePort
          }
          // console.log(param)
          let res = await setOrder(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
            return
          }
          // console.log(res.data)
          if (res.data.result !== '1') {
            this.$message.error(res.data.message)
          } else {
            this.newOrder = false
            this.page_no = 1
            this.getOrderList()
          }
        }
      },
      // 修改订单
      updateOrder (obj) {
        // console.log(obj)
        this.newOrder = true
        this.addOrderTitle = this.$t('message.updateOrderBtnText')
        this.newId = obj.ID
        // this.showOrderNumInput = true
        this.newOrderNum = obj.ORDERNUM
        this.senderCompany = obj.JJGS
        this.senderName = obj.JJR
        this.senderPhone = obj.JJRPHONE
        this.senderEmail = obj.JJREMAIL
        this.goodsNum = obj.WPSL
        this.goodsWeight = obj.WPZL
        this.goodsVolume = obj.WPTJ
        this.senderProvience = obj.PROVINCE1
        this.senderCity = obj.CITY1
        this.senderAddress = obj.GUDING1
        this.addresseeProvience = obj.PROVINCE2
        this.addresseeCity = obj.CITY2
        this.addressee = obj.SJDZ
        this.addresseeCompany = obj.SJGS
        this.addresseeName = obj.SJR
        this.addresseePhone = obj.SJRPHONE
        this.orderRemark = obj.REMARK
        this.containerNumber = obj.JZXNUM
        this.containerOrderModel = obj.JZXSIZE
        this.arrivePort = obj.JZXCITY
      },
      // 删除订单
      delOrders () {
        // console.log(this.selOrders)
        let list = this.selOrders.map(item => {
          return item.ID
        })
        this.delOrder({ ID: list.join(',') })
      },
      delOrder (obj) {
        // console.log(obj)
        this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.del(obj.ID)
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      async del (id) {
        let param = { ID: id }
        let res = await delOrder(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          this.searchFun()
        }
      },
      // 查看物流
      checkLogistics (obj) {
        if (obj.STATE === '2') {
          this.$router.push({ path: '/logisticsCheck', query: { orderNum: obj.ORDERNUM } })
        } else {
          this.$router.push({ path: '/logisticsManage', query: { orderNum: obj.ORDERNUM, id: obj.ID } })
        }
      },
      // 时间排序
      sortChange (obj) {
        // console.log(obj)
        // 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
        this.prop = null
        if (obj.prop === 'addTime') {
          this.prop = 'ADDTIME'
          // param.ORDERNAME = 'ADDTIME'
        }
        this.order = ''
        if (obj.order === 'descending') {
          this.order = 'DESC'
          // param.DOA = 'DESC'
        }
        // this.page_no = 1
        this.searchFun()
      },
      // 普通用户作废订单
      cancellationOrder (id, state) {
        if (state.includes('3')) {
          this.cancel(id)
        } else {
          this.$confirm(this.$t('message.orderCanclePrompt'), this.$t('message.promptTitle'), {
            type: 'warning',
            showClose: false,
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            center: true,
            confirmButtonText: this.$t('message.confirmText'),
            cancelButtonText: this.$t('message.cancleText'),
            callback: action => {
              // console.log(action)
              if (action === 'confirm') {
                this.cancel(id)
              }
            }
          })
        }
      },
      async cancel (id) {
        let param = { ID: id }
        let res = await setOrderState(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          // this.page_no = 1
          this.getOrderList()
        }
      },
      // 导入excel
      importExcel () {
        this.excelNewFileName = ''
        this.excelTable = []
        this.uploadExcel = true
        this.canConfirmImport = true
      },
      beforeAvatarUpload (file) {
        this.importLoading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      },
      handleSuccess (file) {
        // console.log('handleSuccess:', file)
        if (file.result !== '1') {
          this.$message.error(this.$t('message.importExcelError'))
          return
        }
        this.excelNewFileName = file.newFileName
        this.importLoading.close()
      },
      handleError (err) {
        this.importLoading.close()
        // console.log('handleError:', err, file)
        this.$message.error(err)
      },
      async getImportExcel () {
        if (!this.excelNewFileName) {
          return
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = { FILENAME: this.excelNewFileName }
        let res = await readExcel(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        this.excelTable = res.data
        this.canConfirmImport = false
      },
      // 确定导入数据
      async confirmImportExcel () {
        if (!this.excelNewFileName) {
          return
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = { GUDING5: this.excelNewFileName, USERID: this.$store.state.JHSS.personalUserid }
        let res = await confirmImportExcel(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        this.uploadExcel = false
        this.page_no = 1
        // 查询订单列表
        this.getOrderList()
      },
      imgSrc (name) {
        return imgSrc(name)
      },
      // 选择订单
      selectionChange (val) {
        this.selOrders = val
      },
      // 展示设置集装箱弹窗
      showSetContainer () {
        this.containerNumber = ''
        this.containerOrderModel = ''
        this.arrivePort = ''
        this.showContainerSetting = true
      },
      async confirmSetting () {
        if (!this.containerNumber) {
          this.$message.error(this.$t('message.containerOrderNumber'))
        } else if (!this.containerOrderModel) {
          this.$message.error(this.$t('message.containerOrderModel'))
        } else if (!this.arrivePort) {
          this.$message.error(this.$t('message.arrivePort'))
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let orders = this.selOrders.map(item => {
            return item.ID
          })
          let param = { JZXNUM: this.containerNumber, JZXSIZE: this.containerOrderModel, JZXCITY: this.arrivePort, IdLst: orders }
          let res = await setOrdersContainer(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
            return
          }
          this.showContainerSetting = false
          // 查询订单列表
          this.searchFun()
        }
      }
    },
    computed: {
      uploadUrl () {
        return uploadImg()
      },
      url () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
.main_top_search {
  /* height: 180px; */
  height: 126px;
  flex-wrap: wrap;
}
.main_top_search :first-child {
  flex-wrap: wrap;
  flex-shrink: 1;
}
.main_top_search :first-child .search_item, .main_top_search :first-child .search_btn, .main_top_search :first-child .add_btn {
  /* margin-bottom: 10px; */
  margin-top: 10px;
}
.importBtnBox {
  flex-shrink: 0;
  height: 44px;
  border-radius: 4px;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  margin-left: 28px;
  cursor: pointer;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.importBtn {
  flex-shrink: 0;
  display: inline-block;
  height: 44px;
  background: #0066FF;
  border-radius: 4px;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  margin: 0 28px;
  cursor: pointer;
  padding: 0 20px;
}
.barCodeImg {
  width: 52px;
  height: 41px;
}
.addItemInput, .addresseeInput {
  min-height: 46px;
  border: 1px solid #979797;
  border-radius: 4px;
  padding: 0 11px;
  font-size: 18px;
  color: #666666;
  text-align: left;
}
.addItemInput {
  width: 197px;
}
.addItemSelect {
  width: 197px;
  min-height: 46px;
}
.addresseeInput {
  width: 525px;
}
.remarkInput {
  width: 650px;
  min-height: 46px;
  font-size: 18px;
  color: #666666;
  text-align: left !important;
}
/deep/ .remarkInput .el-textarea__inner {
  text-align: left;
}
.checkBtn {
  border: 0;
  font-size: 18px;
  color: #0066FF;
}


/* 导入文件 */
.importLine {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
